import React from 'react';

const PageSeparator = () => {
  return (
    <div className="w-full py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center">
          {/* Elegant separator line */}
          <div className="flex items-center space-x-6">
            <div className="w-12 h-px bg-emerald-800 opacity-30"></div>
            <div className="w-2 h-2 bg-emerald-800 rounded-full"></div>
            <div className="w-12 h-px bg-emerald-800 opacity-30"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageSeparator; 